import { api } from "../../../utils/api";

export const onSubmitEditPermission = async (id, data) => {
  try {
    await api.put(`role/${id}`, data);
  } catch (e) {
    console.log(e);
  }
};
